import { render, staticRenderFns } from "./AppraiserValuationCharacteristics.vue?vue&type=template&id=7007c096&scoped=true&"
import script from "./AppraiserValuationCharacteristics.vue?vue&type=script&lang=ts&"
export * from "./AppraiserValuationCharacteristics.vue?vue&type=script&lang=ts&"
import style0 from "./AppraiserValuationCharacteristics.vue?vue&type=style&index=0&id=7007c096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007c096",
  null
  
)

export default component.exports